import React from 'react';
import { ProposalView } from '../../../components/Proposals/View';

const AdminProposalView: React.FC = () => {
  return (
    <div style={{ width: '100%' }}>
      <ProposalView />
    </div>
  );
};

export default AdminProposalView;
